import { useQuery } from "@tanstack/react-query";
import { devicesApi } from "@/api/devices";

export function useHeartbeats(deviceId: string, limit = 25) {
  return useQuery({
    queryKey: ["device", deviceId, "heartbeats", limit],
    queryFn: () => devicesApi.heartbeats(deviceId, limit),
    refetchInterval: 30_000,
    enabled: !!deviceId,
  });
}

export function useErrorLogs(deviceId: string, limit = 50) {
  return useQuery({
    queryKey: ["device", deviceId, "errors", limit],
    queryFn: () => devicesApi.errorLogs(deviceId, limit),
    refetchInterval: 30_000,
    enabled: !!deviceId,
  });
}

export function useActivityLogs(deviceId: string, limit = 50) {
  return useQuery({
    queryKey: ["device", deviceId, "activity", limit],
    queryFn: () => devicesApi.activityLogs(deviceId, limit),
    refetchInterval: 30_000,
    enabled: !!deviceId,
  });
}

export function useFirmwareUpdates(deviceId: string, limit = 50) {
  return useQuery({
    queryKey: ["device", deviceId, "firmware-updates", limit],
    queryFn: () => devicesApi.firmwareUpdates(deviceId, limit),
    enabled: !!deviceId,
  });
}
